export default {
  'coupon.error_code.E0009': 'このクーポンは期限切れです',
  'coupon.error_code.E0010': 'このクーポンは配布上限に達しました',
  'coupon.error_code.E0011': 'このクーポンは既に受け取っています',
  'coupon.error_code.E0012': 'このクーポンは既に転送されています。友だちに受け取りを依頼してください',
  'coupon.error_code.E0013': 'このクーポンは期限切れのため受け取れません',
  'coupon.error_code.E0014': '受け取り可能時間を過ぎています',
  'coupon.error_code.E0015': '申し訳ありません。友だちが転送をキャンセルしました',
  'coupon.error_code.E0016': 'クーポン情報が不正のため受け取りに失敗しました',
  'coupon.error_code.E0017': 'ポイント不足のため交換できません',
  'coupon.error_code.E0018': 'ポイント付与条件を満たしていません',
  'coupon.error_code.E0019': '申し訳ありません。会員ランクが受け取り条件を満たしていません。',
  'coupon.error_code.E0020': 'このクーポンは受け取り期限を過ぎています',
  'coupon.error_code.E0021': '特典ポイントの受け取りに失敗しました',
  'coupon.error_code.E0022': 'このクーポンは {start} から {end} まで受け取れます',
  'coupon.error_code.E0023': 'このクーポンは削除されています',
  'coupon.error_code.E0024': 'クーポンの付与に失敗しました',
  'coupon.error_code.default': 'クーポンの受け取りに失敗しました',
  'coupon.collect.success.coupon': 'クーポンを獲得しました',
  'coupon.collect.success.point': 'ポイントを獲得しました',
} as Record<string, string>;
